import React from 'react'
import { useTranslation } from 'react-i18next'

function RewardingTasksHeader({ rewardingSelection, handleRewardingButton }) {
    const { t } = useTranslation()
    return (
        <div className="feed-rewarding-header">
            <div className={`rewarding-header-button ${rewardingSelection === 'tasks' ? 'rewarding-header-button-selected' : ''}`} onClick={() => handleRewardingButton('tasks')}>
                <div className={`rewarding-header-button-text ${rewardingSelection === 'tasks' ? 'rewarding-header-button-text-selected' : ''}`}>{t('tasks')}</div>
            </div>
            <div className={`rewarding-header-button ${rewardingSelection !== 'tasks' ? 'rewarding-header-button-selected' : ''}`} onClick={() => handleRewardingButton('dumo')}>
                <div className={`rewarding-header-button-text ${rewardingSelection !== 'tasks' ? 'rewarding-header-button-text-selected' : ''}`}>{t('Achievements')}</div>
            </div>
        </div>
    )
}

export default RewardingTasksHeader
